module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"FooterBottom":{"inspiIdentity":"Vývoj v {inspirum}, internetový obchod {inspishop}.","paymentMethods":"Platební metody"}},"en":{"FooterBottom":{"inspiIdentity":"Development in {inspirum}, internet store {inspishop}.","paymentMethods":"Payment methods"}}}')
  delete Component.options._Ctor
}
